module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/Phone-call.22db71e1.svg";